export default "__VITE_ASSET__DVaPymbK__"